import React from "react"

import { Tag } from "antd"
import { useTranslation } from "react-i18next"
import { DeliveryNote, DeliveryNoteStatusEnum } from "../types/deliveryNote.interfaces"

interface DeliveryNotesStatusTagProps {
    deliveryNote: DeliveryNote
    className?: string
}

const statusClasses = {
    [DeliveryNoteStatusEnum.DELIVERY_NOTE_DOCUMENT_PENDING]: "ant-tag-yellow",
    [DeliveryNoteStatusEnum.DELIVERY_NOTE_DOCUMENT_SUCCESS]: "ant-tag-success",
    [DeliveryNoteStatusEnum.DELIVERY_NOTE_PARTIALLY_LINKED]: "ant-tag-blue",
    [DeliveryNoteStatusEnum.DELIVERY_NOTE_FULLY_LINKED]: "ant-tag-success",
    [DeliveryNoteStatusEnum.DELIVERY_NOTE_DELETED]: "ant-tag-red",
}

const determineDeliveryNoteStatus = (deliveryNote: DeliveryNote) => {
    if (deliveryNote?.deleted) {
        return DeliveryNoteStatusEnum.DELIVERY_NOTE_DELETED
    }

    const hasLinks = deliveryNote?.lineItems.every((item) => item.purchaseOrderLink)
    const someLinks = deliveryNote?.lineItems.some((item) => item.purchaseOrderLink)

    if (hasLinks) {
        return DeliveryNoteStatusEnum.DELIVERY_NOTE_FULLY_LINKED
    }

    if (someLinks) {
        return DeliveryNoteStatusEnum.DELIVERY_NOTE_PARTIALLY_LINKED
    }

    return deliveryNote?.deliveryNoteDocument ? DeliveryNoteStatusEnum.DELIVERY_NOTE_DOCUMENT_SUCCESS : DeliveryNoteStatusEnum.DELIVERY_NOTE_DOCUMENT_PENDING
}

export const DeliveryNotesStatusTag = ({ deliveryNote, className = "" }: DeliveryNotesStatusTagProps) => {
    const { t } = useTranslation()

    const status = determineDeliveryNoteStatus(deliveryNote)

    return (
        <Tag className={`${statusClasses[status]}  ${className}`} data-testid="finway:deliveryNotesStatusTag:status">
            {t(`deliveryNote:states.${status}`)}
        </Tag>
    )
}
